/**
 * Labels fallback para colunas de exportação de Ordens de Serviço.
 * Usado quando GET /serviceorders/export/columns não estiver disponível.
 */
export const SERVICE_ORDER_EXPORT_COLUMN_LABELS: Record<string, string> = {
  numeroOS: 'Nº OS',
  NumeroOS: 'Nº OS',
  tipoOS: 'Tipo OS',
  TipoOS: 'Tipo OS',
  status: 'Status',
  Status: 'Status',
  dataAbertura: 'Data Abertura',
  DataAbertura: 'Data Abertura',
  horaAbertura: 'Hora Abertura',
  HoraAbertura: 'Hora Abertura',
  veiculoPlaca: 'Veículo (Placa)',
  VeiculoPlaca: 'Veículo (Placa)',
  setorAbertura: 'Setor Abertura',
  SetorAbertura: 'Setor Abertura',
  setorAtual: 'Setor Atual',
  dataPrevistaConclusao: 'Previsão Conclusão',
  DataPrevistaConclusao: 'Previsão Conclusão',
  dataConclusao: 'Data Conclusão',
  DataConclusao: 'Data Conclusão',
  clienteNome: 'Cliente',
  ClienteNome: 'Cliente',
  mecanicoNome: 'Mecânico',
  MecanicoNome: 'Mecânico',
  descricao: 'Descrição',
  Descricao: 'Descrição',
  valorEstimado: 'Valor Estimado',
  ValorEstimado: 'Valor Estimado',
  valorFinal: 'Valor Final',
  ValorFinal: 'Valor Final',
  km: 'Quilometragem',
  Km: 'Quilometragem',
  motivoAbertura: 'Motivo Abertura',
  MotivoAbertura: 'Motivo Abertura',
  unidadeNome: 'Unidade',
  UnidadeNome: 'Unidade',
  usuarioNome: 'Usuário Abertura',
  UsuarioNome: 'Usuário Abertura',
  contratoNumero: 'Nº Contrato',
  ContratoNumero: 'Nº Contrato',
  b2bContractId: 'ID Contrato B2B',
  B2BContractId: 'ID Contrato B2B',
  b2bContractItemId: 'ID Item B2B',
  B2BContractItemId: 'ID Item B2B',
  fuelLevel: 'Nível Combustível',
  FuelLevel: 'Nível Combustível',
  openingMileage: 'KM Abertura',
  OpeningMileage: 'KM Abertura',
  entryDate: 'Data Entrada',
  EntryDate: 'Data Entrada',
  startWorkDate: 'Início Serviço',
  StartWorkDate: 'Início Serviço',
  deadlineDate: 'Prazo',
  DeadlineDate: 'Prazo',
  endWorkDate: 'Fim Serviço',
  EndWorkDate: 'Fim Serviço',
  pickupDate: 'Data Retirada',
  PickupDate: 'Data Retirada',
  isScheduled: 'Agendada',
  IsScheduled: 'Agendada'
};

/** Colunas pré-selecionadas por padrão no modal de exportação. */
export const DEFAULT_SERVICE_ORDER_EXPORT_KEYS = [
  'NumeroOS',
  'TipoOS',
  'Status',
  'DataAbertura',
  'VeiculoPlaca',
  'SetorAbertura',
  'DataPrevistaConclusao'
];

export function isDefaultServiceOrderExportKey(key: string): boolean {
  const normalized = key.trim().toLowerCase();
  return DEFAULT_SERVICE_ORDER_EXPORT_KEYS.some(
    defaultKey => defaultKey.toLowerCase() === normalized
  );
}

/** Lista estática de keys quando a API de colunas não responde. */
export const FALLBACK_SERVICE_ORDER_EXPORT_COLUMNS = [
  'NumeroOS',
  'TipoOS',
  'Status',
  'DataAbertura',
  'HoraAbertura',
  'VeiculoPlaca',
  'SetorAbertura',
  'DataPrevistaConclusao',
  'DataConclusao',
  'ClienteNome',
  'MecanicoNome',
  'Descricao',
  'ValorEstimado',
  'ValorFinal',
  'Km',
  'MotivoAbertura',
  'UnidadeNome',
  'UsuarioNome',
  'ContratoNumero',
  'b2bContractId',
  'b2bContractItemId',
  'fuelLevel',
  'openingMileage',
  'entryDate',
  'startWorkDate',
  'deadlineDate',
  'endWorkDate',
  'pickupDate',
  'isScheduled'
];
